/**
 * Public link paths (QA 2026-10-16): every /r/* and /l/* path is a public page, whatever follows. A token that isn't
 * 22 URL-safe characters can never be valid, so it shows "This link isn't valid or was turned off" at once instead of
 * falling through to the signed-in app ("Couldn't reach …" for a signed-out visitor).
 */
export const LINK_GONE_TITLE = "This link isn't valid or was turned off";

export type PublicRoute = { kind: 'r' | 'l'; token: string | null };

export function publicRoute(path: string): PublicRoute | null {
  const m = /^\/(r|l)(?:\/([^/]*))?\/?$/.exec(path) ?? /^\/(r|l)\/(.*)$/.exec(path);
  if (!m) return null;
  const raw = m[2] ?? '';
  return { kind: m[1] as 'r' | 'l', token: /^[A-Za-z0-9_-]{22}$/.test(raw) ? raw : null };
}
